<template>
  <form @submit.prevent="onSearch">
    <div class="row mb-3">
      <div class="col-lg-3 col-md-6 col-sm-12">
        <div v-if="officeDropdown && officeDropdown.length">
          <SelectVue
              v-model="filters.officeId"
              :options="officeDropdown"
              :is-clear="true"
              :placeholder="$t('placeholder.office_name')"
          />
        </div>
      </div>
      <div class="col-lg-3 col-md-6 col-sm-12">
        <div v-if="lastNameDropdown && lastNameDropdown.length">
          <SelectVue
              v-model="filters.lastName"
              :options="lastNameDropdown"
              :is-clear="true"
              :placeholder="$t('placeholder.last_name')"
          />
        </div>
      </div>
      <div class="col-lg-2 col-md-6 col-sm-12">
        <div v-if="engagementTypeDropdown && engagementTypeDropdown.length">
          <SelectVue
              v-model="filters.engagementType"
              :options="engagementTypeDropdown"
              :is-clear="true"
              :placeholder="$t('placeholder.engagement_type')"
          />
        </div>
      </div>
      <div class="col-lg-2 col-md-6 col-sm-12">
        <div v-if="statusDropdown && statusDropdown.length">
          <SelectVue
              v-model="filters.status"
              :options="statusDropdown"
              :is-clear="true"
              :placeholder="$t('placeholder.status')"
          />
        </div>
      </div>
      <div class="col-lg-2 col-sm-12 col-12 d-flex d-lg-block justify-content-center">
        <SearchButton
            type="submit"
            :label="$t('general.button.search')"
            :loading="loading"/>

<!--        <button type="submit" class="btn btn-primary custom_search_button2" :disabled="loading">-->
<!--          <span v-if="loading" class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>-->
<!--          <span v-if="!loading">{{ $t('general.button.search') }}</span>-->
<!--          <span v-else>{{ $t('general.button.search_in_progress') }}</span>-->
<!--        </button>-->
      </div>
    </div>
  </form>
</template>

<script setup>
import SelectVue from '@/components/SelectVue.vue';
import { defineEmits, defineProps, toRefs } from 'vue';
import SearchButton from "@/components/button/SearchButton.vue";

const props = defineProps({
  filters: {
    type: Object,
    required: true,
  },
  officeDropdown: {
    type: Array,
    required: true,
  },
  lastNameDropdown: {
    type: Array,
    required: true,
  },
  engagementTypeDropdown: {
    type: Array,
    required: true,
  },
  statusDropdown: {
    type: Array,
    required: true,
  },
  loading: {
    type: Boolean,
    default: false,
  },
});

// Emit search event
const emit = defineEmits([ 'search' ]);

// Use toRefs to maintain reactivity
const { filters }            = toRefs(props);
const officeDropdown         = toRefs(props)[ 'officeDropdown' ];
const lastNameDropdown       = toRefs(props)[ 'lastNameDropdown' ];
const engagementTypeDropdown = toRefs(props)[ 'engagementTypeDropdown' ];
const statusDropdown         = toRefs(props)[ 'statusDropdown' ];

function onSearch() {
  emit('search', 1, undefined, filters.value);
}

</script>

<style scoped>
</style>
